import { Badge } from '@/components/ui/Badge/badge';
import { UnselectButton } from '@/components/ui/multiple-selector';
import { Label } from '@certhon/models';
import { cn } from '@/lib/utils';

interface LabelBadgeProps {
  label: Label;
  variant?: 'default' | 'outline';
  showUnselect?: boolean;
  onUnselect?: () => void;
  deleted?: boolean;
}

export function LabelBadge({
  label,
  variant = 'outline',
  showUnselect = false,
  onUnselect,
  deleted,
}: LabelBadgeProps) {
  const color = label.color ? `#${label.color}` : '#999999';

  // Only use inline styles for the dynamic colors, use Tailwind for everything else
  const colorStyles =
    variant === 'outline'
      ? {
          color: `light-dark(${color}, color-mix(in srgb, ${color} 50%, white))`,
          borderColor: color,
          backgroundColor: `color-mix(in srgb, ${color} 20%, var(--color-card))`,
        }
      : { backgroundColor: color, color: '#ffffff' };

  return (
    <Badge
      variant={variant}
      style={colorStyles}
      className={cn(
        'relative overflow-visible',
        deleted &&
          `after:absolute after:-inset-x-1 after:inset-y-0 after:top-1/2 after:h-0.5
          after:w-[calc(100%+0.5rem)] after:-translate-y-1/2 after:rotate-[-5deg]
          after:rounded-full after:bg-red-500 after:opacity-100`,
      )}
      title={label.description || label.name}
    >
      {label.name}
      {showUnselect && onUnselect && <UnselectButton onUnselect={onUnselect} />}
    </Badge>
  );
}
